import Swiper from "swiper";
import { Pagination, Autoplay, Navigation } from "swiper/modules";

export const flipGalleryCarousel = () => {
	const blocks = document.querySelectorAll('.flip-gallery-carousel-block');
	if (!blocks.length) return;

	blocks.forEach((block) => {
		const slideWrap = block.querySelector(".flip-gallery-carousel-block-inner");
		if (!slideWrap) return;

		const items = slideWrap.querySelectorAll('.item-gallery');
		const countItem = items.length;

		let opt = block.dataset.slider ? JSON.parse(block.dataset.slider) : {};

		let defaultOptions = {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: 4,
			spaceBetween: 20,
			loop: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false
			},
			navigation: {
				nextEl: block.querySelector('.swiper-button-next'),
				prevEl: block.querySelector('.swiper-button-prev'),
			},
			pagination: {
				el: block.querySelector('.swiper-pagination'),
				clickable: true
			},
			breakpoints: {
				0: {
					slidesPerView: 1
				},
				992: {
					slidesPerView: 2
				},
				1200: {
					slidesPerView: 4
				}
			}
		};

		const finalOptions = {
			...defaultOptions,
			...opt
		};

		let shouldInit = false;
		const width = window.innerWidth;

		if (width < 576) {
			shouldInit = countItem > 1;
		} else if (width < 992) {
			shouldInit = countItem > 2;
		} else {
			shouldInit = countItem > (opt.slidesPerView || 4);
		}

		if (!shouldInit) {
			slideWrap.classList.add('no-carousel');
			return;
		}

		slideWrap.classList.add('swiper');
		const wrapper = slideWrap.querySelector('.swiper-wrapper');
		if (!wrapper) return;

		const swiper = new Swiper(slideWrap, finalOptions);
	});
};